// ═══════════════════════════════════════════════════════════════════════════
// sponsorsAdmin.js — CRUD for the sponsors table (migration 072), behind the
// /admin "Sponsors" tab. Gated server-side by has_cms_access; every mutation
// is written to the audit log.
// ═══════════════════════════════════════════════════════════════════════════

import { supabase } from './supabase';
import { logAdminAction } from './audit';

function unwrap(data, error) {
  if (error) throw new Error(error.message || 'Request failed');
  if (data?.error) throw new Error(data.error);
  return data;
}

/** All sponsors (incl. inactive), position-ordered — for the admin table. */
export async function listSponsorsAdmin() {
  if (!supabase) return [];
  const { data, error } = await supabase.rpc('admin_list_sponsors');
  return unwrap(data, error)?.sponsors || [];
}

/** Insert (id null) or update a sponsor. `fields.niches` is an array. */
export async function saveSponsor(id, fields = {}) {
  const { data, error } = await supabase.rpc('admin_save_sponsor', {
    p_id:        id || null,
    p_name:      fields.name || '',
    p_category:  fields.category ?? null,
    p_logo:      fields.logo ?? null,
    p_tagline:   fields.tagline ?? null,
    p_budget:    fields.budget ?? null,
    p_min_eps:   Number.isFinite(fields.min_eps) ? fields.min_eps : 0,
    p_niches:    Array.isArray(fields.niches) ? fields.niches : [],
    p_status:    fields.status || 'open',
    p_is_active: typeof fields.is_active === 'boolean' ? fields.is_active : true,
    p_position:  Number.isFinite(fields.position) ? fields.position : 0,
  });
  const out = unwrap(data, error);
  logAdminAction(id ? 'update_sponsor' : 'add_sponsor', {
    targetType: 'sponsor', targetId: out?.id || id, detail: { name: fields.name },
  });
  return out;
}

export async function removeSponsor(id) {
  const { data, error } = await supabase.rpc('admin_remove_sponsor', { p_id: id });
  const out = unwrap(data, error);
  logAdminAction('remove_sponsor', { targetType: 'sponsor', targetId: id });
  return out;
}
